import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import "./styles/classes.scss";
import "./index.css";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { ToastContainer } from "react-toastify";
import { Toaster } from "react-hot-toast";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <App />
      <Toaster
        toastOptions={{
          className: "",
          style: {
            fontFamily: "var(--poppins)",
            fontWeight: "var(--font-weight-400)",
          },
        }}
      />{" "}
    </Provider>
  </BrowserRouter>
);
